import { Box, IconButton, Stack, Typography, StackProps } from '@mui/material'
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore'
import { useHistory } from 'react-router'
import React from 'react'

interface ChildPageHeaderProps {
  title: string
  subTitle?: string
  slot?: {
    action?: React.ReactNode
  }
  hideBackButton?: boolean
  redirectUrl?: string
  variant?: 'default' | 'compact'
  slotProps?: { root?: StackProps }
  noMargin?: boolean
}

const ChildPageHeader: React.FC<ChildPageHeaderProps> = ({
  title,
  subTitle,
  slot,
  hideBackButton,
  redirectUrl,
  variant = 'default',
  slotProps,
  noMargin,
}) => {
  const history = useHistory()

  const handleClickBack = () => {
    redirectUrl ? history.push(redirectUrl) : history.goBack()
  }

  return (
    <Stack
      direction="row"
      spacing={2}
      className={noMargin ? '' : 'tw-mb-4'}
      alignItems="center"
      justifyContent="space-between"
      {...slotProps?.root}
    >
      <Stack direction="row" alignItems="center" gap={1}>
        {!hideBackButton && (
          <IconButton onClick={handleClickBack} size="small" sx={{ p: 0 }}>
            <NavigateBeforeIcon sx={{ fontSize: '34px' }} />
          </IconButton>
        )}
        {variant === 'default' ? (
          <Box flexGrow={1}>
            <Typography variant="subtitle1" component="h1">
              {title}
            </Typography>
            {subTitle && (
              <Typography variant="body1" component="h2" fontWeight={600}>
                {subTitle}
              </Typography>
            )}
          </Box>
        ) : (
          <Typography variant="subtitle1" component="h2" m={0}>
            {title}
          </Typography>
        )}
      </Stack>

      {slot?.action}
    </Stack>
  )
}

export default ChildPageHeader
